import { ApiError, createApiClient, Result, wrapper } from "@/api/base";

const basePath = "campaign-planner/pqa";
const baseClient = createApiClient();

export default class {
	importSteeringRules(file: File): Promise<Result<null, ApiError>> {
		const formData = new FormData();
		formData.append("file", file);
		return wrapper(baseClient.post(`${basePath}/upload`, formData));
	}
}
